import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type MentorSuggestionsType = {
  userId: number;
  filters?: { email: string };
};

const { useGet: useMentorSuggestions } = getCRUDHooks({
  entityName: 'mentorSuggestions',
  get: ({ userId, filters }: MentorSuggestionsType) =>
    clientApi.getOCClient().helpers.user.users.id(userId).mentorSuggestion.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useMentorSuggestions };
